<template>
  <div class="pageWrapper">
    <div class="pageContent">
      <div class="eachBoxStyle firstSection mt-10">
        <div
            v-if="!$vuetify.breakpoint.smAndDown"
            class="title-medium-20 panelPadding"
        >
          {{ $t("newPreSession.personalInformation") }}
        </div>

        <div v-if="!$vuetify.breakpoint.smAndDown" class="divider"></div>

        <v-form ref="passwordForm">
          <div class="panelPadding">
            <div
                :class="
                !$vuetify.breakpoint.smAndDown
                  ? 'body-large-18-medium'
                  : 'body-medium-16-medium mb-3 mt-1'
              "
            >
              {{ $t("newPreSession.howToAddressYou") }}

            </div>

            <v-row no-gutters class=" ">
              <v-col cols="12" lg="6">
                <div
                    class="timezoneInputWrapper"
                    :style="{
                    marginLeft: $vuetify.breakpoint.mdAndDown ? '0px' : '8px',
                  }"
                >
                  <v-text-field

                      :class="$vuetify.breakpoint.mdAndUp && !$vuetify.rtl  ? 'rightMarginLtr' : ''"
                      class="timezoneInput body-small-14-regular  "
                      :label="$t('profileView.name')"
                      v-model="name"
                      item-text="name"
                      :rules="requiredRules"
                      item-value="value"
                      outlined
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" lg="6">
                <div class="timezoneInputWrapper "

                >

                  <v-text-field
                      class="timezoneInput body-small-14-regular"
                      :label="$t('profileView.family')"
                      item-text="name"
                      v-model="family"
                      :rules="requiredRules"
                      item-value="value"
                      outlined
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <div
                class="mt-3 mb-3"
                :class="
                !$vuetify.breakpoint.smAndDown
                  ? 'body-large-18-medium'
                  : 'body-medium-16-medium'
              "
            >
              {{ $t("newPreSession.otherInfoHelp") }}

            </div>

            <v-row no-gutters class="">
              <v-col cols="12" lg="6">
                <div
                    class="timezoneInputWrapper"
                    :style="{marginLeft: $vuetify.breakpoint.mdAndDown ? '0px' : '8px',}"
                >
                  <v-autocomplete
                      :class="$vuetify.breakpoint.mdAndUp && !$vuetify.rtl  ? 'rightMarginLtr' : ''"
                      class="timezoneInput body-small-14-regular"
                      :items="contires"
                      :label="$t('newPreSession.countryLabel')"
                      v-model="country"
                      item-text="label"
                      :rules="requiredRules"
                      item-value="id"
                      outlined
                  >
                    <template v-slot:append>
                      <v-icon color="#757575" class="custom-dropdown-arrow">
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" lg="6">
                <div class="timezoneInputWrapper"

                >
                  <v-autocomplete
                      class="timezoneInput body-small-14-regular"
                      :items="knway"
                      v-model="chosen_knway"
                      :label="$t('newPreSession.howHeardAboutUs')"
                      item-text="title"
                      item-value="value"
                      outlined
                  >
                    <template v-slot:append>
                      <v-icon color="#757575" class="custom-dropdown-arrow">
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div v-if="!$vuetify.breakpoint.smAndDown" class="inspirationDiv">
          <img
              src="@/assets/newPreSession/satisfySticker.png"
              alt=""
              class="smallSleeve"
          />
          <div class="title-small-14" style="color: #035184">
            {{ $t("newPreSession.userFeedback") }}

          </div>
        </div>
        <v-row
            v-if="!$vuetify.breakpoint.smAndDown"
            no-gutters
            class="submitSectionMargins align-center justify-center"
        >
          <v-col lg="6" cols="12">
            <div v-if="finalDate">
              <span class="body-large-18-medium">{{
                  finalDate.date.split(",")[0] ?? ""
                }}</span>
              <span class="" style="color: #035184">{{
                  finalDate.date.split(",")[1] ?? ""
                }}</span>
            </div>
            <div v-else>
              <span style="color: #424242" class="body-large-18-medium"
              >{{ $t("newPreSession.chooseDateAndTime") }}
              </span
              >
            </div>
          </v-col>

          <v-col lg="6" cols="12" class="d-flex align-end justify-end">
            <div
                @click="submitForm"
                class="title-small-16"
                :class="['submitBtn', { 'is-disabled': loading }]"
                id="new-pre-session-step-three-profile"
            >
              {{ $t("newPreSession.submitAndContinue") }}

            </div>
          </v-col>
        </v-row>
        <div class="mobileSpacer"></div>
      </div>
    </div>

    <div v-if="$vuetify.breakpoint.smAndDown" class="fixedFooter">
      <div
          id="new-pre-session-step-three-profile"
          @click="submitForm"
          class="title-small-16"
          :class="['submitBtn', { 'is-disabled': loading }]"
      >
        {{ $t("newPreSession.submitAndContinue") }}

      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import EventsMixins from "@/mixins/EventsMixins";
/*eslint-disable*/
export default {
  props: {
    finalDate: {
      type: Object,
    },
  },

  data() {
    return {
      name: "",
      loading: false,
      family: "",
      chosen_knway: "",
      country: null,
      timezonesList: [],
      knway_meta: null,
      knway: [
        {value: "google", title: this.$t("knway.google")},
        {value: "twitter", title: this.$t("knway.twitter")},
        {value: "instagram", title: this.$t("knway.instagram")},
        {value: "podcast", title: this.$t("knway.podcast")},
        {value: "bannerads", title: this.$t("knway.bannerads")},
        {value: "friends", title: this.$t("knway.friends")},
        {value: "youtube", title: this.$t("knway.youtube")},
        // {value: "site", title: this.$t('knway.site')},
        // {value: "other", title: this.$t("knway.other")},
      ],
    };
  },
  mounted() {

    console.log(this.prepareDefaultTimezone(), 'timezone')


    let times = JSON.parse(JSON.stringify(this.timezones));
    this.timezonesList = times.map((item) => {
      item.text = item.text + "  " + moment().tz(item.text).format("Z");
      return item;
    });
    this.fillProfileData();
  },
  mixins: [EventsMixins],
  computed: {
    ...mapGetters({profile: "getProfile"}),
  },
  methods: {
    fillProfileData() {
      this.name = this.profile.firstname;
      this.family = this.profile.lastname;
      this.country = this.profile.country_id
      this.chosen_knway = this.profile.knway;

      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.resetValidation();
        }
      });
    },

    submitForm() {
      if (this.loading) return;

      if (this.$refs.passwordForm.validate()) {
        this.loading = true;
        this.$emitEvent("setLoading", true);
        // let country_name = this.contires.find(item => item.id == this.country)
        this.requesting("auth", "editProfile", "", {
          name: this.name,
          family: this.family,
          familiar_by: this.chosen_knway,
          country_id: this.country,
          familiar_by_meta: "other",
          // country_name: country_name?.label
        })
            .then(() => {

              this.SendEventTrk({
                event_id: 'presession_book_' + Date.now(),
                name: 'pre_session_book',
                email: this.profile.email,
                first_name: this.profile.firstname,
                last_name: this.profile.lastname,
                payload: {}
              })


              this.$emitEvent("setLoading", true);
              this.requesting("preSessionRequests", "setSession", null, {
                time_id: this.finalDate.time_id,
              })
                  .then((resp) => {
                    let counselor =
                        resp.data?.session?.session?.userSession?.doctor?.user;
                    this.$emit("counselor-data", {
                      name: counselor.full_name,
                      avatar: counselor.avatar,
                      en_name: counselor.en_name + " " + counselor.en_family
                    });
                    this.$emit("change-step", 3);
                  })
                  .finally(() => {
                    this.$emitEvent("setLoading", false);
                    this.loading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                    this.$emitEvent("setLoading", false);
                    this.loading = false;
                    const msg =
                        err?.response?.data?.message || this.$t("newPreSession.slotUnavailable");
                    this.$emitEvent("notify", {color: "red", title: msg});

                    if (err?.response?.data?.data?.status === 1001) {
                      this.$emitEvent("notify", {
                        color: "orange",
                        title: this.$t("newPreSession.slotUnavailable"),
                      });
                      this.$emit("change-step", 1);
                    }
                  });
            })
            .catch(() => {
              this.$emitEvent("setLoading", false);
              this.loading = false;
            });
      } else {
        this.$emitEvent("notify", {
          color: "red",
          title: this.$t("newPreSession.fillRequiredFields"),
        });
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 300px) and (max-width: 1000px) {
  .eachBoxStyle {
    width: 700px !important;
  }
}

@media (min-width: 200px) and (max-width: 600px) {
  .timezoneInput {
    margin-top: 0 !important;
  }

  .mobileSpacer {
    width: 100%;
    height: 100px;
    background-color: white;
  }

  .pageWrapper {
    width: 100%;
    height: auto !important;
  }

  .submitBtn {
    width: 342px !important;
    height: 48px;
  }

  .firstSection {
    margin-top: 0 !important;
    border-radius: 0 !important;
  }

  .eachBoxStyle {
    background: #fff;
    border-radius: 12px;

    width: 100% !important;
    height: auto;
    border-top: 1px solid #eaf0f6;
    transition: height 0.3s ease;
  }
}

.pageWrapper {
  width: 100%;
  height: 100vh;
}

.eachBoxStyle {
  background: #fff;
  border-radius: 12px;

  width: 900px;
  height: auto;
  border-top: 1px solid #eaf0f6;
  transition: height 0.3s ease;
}

.panelPadding {
  padding: 16px 24px 0 24px;
}

.pageContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.firstSectionTop {
  border-bottom: 1px solid #eaf0f6;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eaf0f6;
  margin: 16px 0;
}

.timezoneInputWrapper :deep(.v-input__slot) fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
  border-radius: 8px !important;
}

.timezoneInputWrapper :deep(.v-input__slot):hover fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-input--is-focused .v-input__slot) fieldset {
  border-color: #3cbe8b !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-text-field__details) {
  display: none !important;
}

.timezoneInput {
  margin-top: 16px;
  border-radius: 12px !important;
}

.inspirationDiv {
  padding: 12px 28px;
  color: #035184;
  margin-top: 68px;
  width: 100%;
  background-color: #c5effe66;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.smallSleeve {
  width: 28px;
  height: 28px;
  margin-left: 5px;
}

.submitSectionMargins {
  background-color: white;
  height: 80px;
  margin: 3px 24px;
}

.submitBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: 390px;
  height: 48px;
  background-color: #39c990;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.fixedFooter {
  width: 100%;
  position: fixed;
  bottom: 16px;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.submitBtn:hover {
  background-color: #2ebd84; /* a slightly darker green */
  box-shadow: 0px 4px 12px rgba(57, 201, 144, 0.4); /* subtle greenish shadow */
}

.timezoneInputWrapper :deep(.v-input__control),
.timezoneInputWrapper :deep(input),
.timezoneInputWrapper :deep(.v-label) {
  font-size: 14px;
  font-weight: 400;
  font-family: YekanBakh !important;
}

.submitBtn.is-disabled {
  background-color: #bdbdbd !important;
  color: #fafafa !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  opacity: 0.8;
  pointer-events: none;
  transition: none;
}

.rightMarginLtr {
  margin-right: 8px !important;
}

</style>
